import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { MdKeyboardArrowRight } from 'react-icons/md';

import { Container, Button } from './styles';

export default function Docs({ label, link }) {
  return (
    <Container>
      <Button>
        <Link to={link}>
          <div>
            <h3>{label}</h3>
          </div>
          <MdKeyboardArrowRight />
        </Link>
      </Button>
    </Container>
  );
}

Docs.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
};
